/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { FunctionalComponent, h } from '@stencil/core';
import { getString } from '../../utils/l10n';
import { FortifyStatus } from '../fortify-status';
import { FortifyButton } from '../fortify-button';

export interface IFortifyNotDetectedProps {
  downloadAppLink: string;
}

export const FortifyNotDetected: FunctionalComponent<IFortifyNotDetectedProps> = (props) => {
  const { downloadAppLink } = props;

  return (
    <FortifyStatus
      title={getString('detect.title')}
      description={getString('detect.description')}
    >
      <FortifyButton
        variant="primary"
        href={downloadAppLink}
      >
        {getString('actions.install')}
      </FortifyButton>
    </FortifyStatus>
  );
};
